import React, { FC, PropsWithChildren, ReactNode } from 'react';

import { Typography } from '../../../Typography';


type HeaderProps = PropsWithChildren<ReactNode>;
export const Header: FC<HeaderProps> = ({ children }) => (
    <Typography
        variant='boldCaption1'
        color='grayscale.shade95'
        p={2}
        textAlign='center'
    >
        {children}
    </Typography>
);
